var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mounting-form"},_vm._l((_vm.mountingItems),function(item,index){return _c('mounting-item',{key:index,attrs:{"data":item,"selected":_vm.mounting && item.key === _vm.mounting.key}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }